<div class="container">

    <div class="log-header" *ngIf="sourceId!='caisostage.com' && sourceId!='caiso.com' && sourceId!='wem'">
        <img src="./assets/CAISOlogo.jpg">
    </div>
    <h1>{{pageHeading}}</h1>
    <p>Please enter your contact information, <span *ngIf="sourceId=='caiso.com' || sourceId=='wem'">select your email subscription
            preferences,</span> and click Submit. </p>

    <div class="container px-2 pt-2">

        <div id="divPageProgress" class="row loaderDiv" *ngIf="!dataLoaded">
            <div class="col-12 text-center">
                <div class="text-primary progressAnimation">
                    <div class="loader"></div>
                </div>
            </div>
        </div>



        <div *ngIf="requestProcessed || requestFailed" class="operationMessage"
            [ngClass]="{'failedRequestMessage' : requestFailed}">
            {{messageToDisplay}}
        </div>

        <div class="row">
            <div class="col-lg-8 col-md-12 col-sm-12">
                <form #subscriptionForm="ngForm" (ngSubmit)="submit(subscriptionForm)"
                    *ngIf="(!requestProcessed && !requestFailed) && dataLoaded">
                    <div class="form-group mt-2">
                        <label for="firstName">First name<span class="required">*</span></label>
                        <div *ngIf="firstName.invalid && (firstName.dirty || firstName.touched)" class="errorMessage">
                            <div *ngIf="firstName.errors.required">
                                First name is required.
                            </div>
                            <div *ngIf="firstName.errors.maxlength">
                                Last name exceeded the max length of 50.
                            </div>
                        </div>

                        <input #firstName="ngModel" required maxlength="50" type="text" name="firstName"
                            autocomplete="off"
                            [ngClass]="{'is-invalid' : firstName.invalid && (firstName.dirty || firstName.touched)}"
                            class="form-control  ng-untouched ng-pristine ng-valid clear" [(ngModel)]="model.firstName">

                    </div>
                    <div class="form-group mt-2">
                        <label for="lastName">Last name<span class="required">*</span></label>
                        <div *ngIf="lastName.invalid && (lastName.dirty || lastName.touched)" class="errorMessage">
                            <div *ngIf="lastName.errors.required">
                                Last name is required.
                            </div>
                            <div *ngIf="lastName.errors.maxlength">
                                Last name exceeded the max length of 50.
                            </div>
                        </div>

                        <input #lastName="ngModel" required maxlength="50" type="text" name="lastName"
                            autocomplete="off"
                            [ngClass]="{'is-invalid' : firstName.invalid && (firstName.dirty || firstName.touched)}"
                            class="form-control  ng-untouched ng-pristine ng-valid clear" [(ngModel)]="model.lastName">


                    </div>
                    <div class="form-group mt-2">
                        <label for="emailAddress">Email address<span class="required">*</span></label>
                        <div *ngIf="emailAddress.invalid && (emailAddress.dirty || emailAddress.touched)"
                            class="errorMessage">
                            <div *ngIf="emailAddress.errors.required">
                                Email address is required.
                            </div>
                            <div *ngIf="emailAddress.errors.pattern">
                                Email address is not in valid format.
                            </div>
                        </div>

                        <div *ngIf="caisoEmailNotAllowed && (emailAddress.dirty || emailAddress.touched)"
                            class="errorMessage">
                            '@caiso.com' email address not allowed.
                        </div>



                        <input #emailAddress="ngModel" required type="email" name="emailAddress" autocomplete="off"
                            [ngClass]="{'is-invalid' : (emailAddress.invalid && (emailAddress.dirty || emailAddress.touched) 
                                 || caisoEmailNotAllowed && (emailAddress.dirty || emailAddress.touched))}"
                            pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
                            class="form-control  ng-untouched ng-pristine ng-valid clear" 
                            (input)="onEmailChange($event.target.value)"
                            [(ngModel)]="model.emailAddress">


                    </div>
                    <div class="form-group mt-2">
                        <label for="organization" *ngIf="sourceId!='mediabriefing'"> 
                            Organization <span class="required" *ngIf="isOrgNameMandatory">*</span></label>
                        <label for="organization" *ngIf="sourceId=='mediabriefing'"> 
                            Media outlet <span class="required" *ngIf="isOrgNameMandatory">*</span>
                            <small class="d-block fw-normal">
                                You must be a member of the media to attend briefings.
                            </small></label>

                        <div *ngIf="organization.invalid && (organization.dirty || organization.touched) && sourceId!='mediabriefing'"
                            class="errorMessage">
                            <div *ngIf="organization.errors.required">
                                Organization is required.
                            </div>
                            <div *ngIf="organization.errors.maxlength">
                                Organization the max length of 50.
                            </div>
                        </div>
                        <div *ngIf="organization.invalid && (organization.dirty || organization.touched) && sourceId=='mediabriefing'"
                            class="errorMessage">
                            <div *ngIf="organization.errors.required">
                                Media outlet is required.
                            </div>
                            <div *ngIf="organization.errors.maxlength">
                                Media outlet the max length of 50.
                            </div>
                        </div>

                        <input #organization="ngModel" type="text" [required]=isOrgNameMandatory name="organization"
                            [ngClass]="{'is-invalid' : organization.invalid && (organization.dirty || organization.touched)}"
                            class="form-control" [(ngModel)]="model.organization" autocomplete="off" maxlength="50">

                    </div>

                    <div class="form-group mt-2" *ngIf="isoEvents.length>1">
                        <label for="eventNames">Subscribe to:</label>
                        <div *ngIf="eventsSelected.invalid  && (eventsSelected.dirty || eventsSelected.touched)"
                            class="errorMessage">
                            <div *ngIf="eventsSelected.errors.required">
                                At least one notification needs to be selected.
                            </div>
                        </div>

                        <input #eventsSelected="ngModel" required type="hidden" name="eventsSelected"
                            class="form-control" [(ngModel)]="selectedEvents">



                        <div *ngFor="let evt of isoEvents; let i=index" class="col-md-2">
                            <label class="eventText ps-2 p1-1">
                                <input type="checkbox" [value]="evt.eventName"
                                    (change)="onEventSelectionChange($event)">
                                {{evt.eventName}}
                            </label>
                        </div>
                    </div>

                    <div class="form-group mt-2 mb-2" *ngIf="sourceId=='mediabriefing'">
                        <p>The ISO reserves the right to remove subscribers from this email list at any time, without notice.</p>
                    </div>
                    <hr>
                    <button class="btn btn-primary mt-4" type="submit">Submit</button>
                </form>
            </div>
        </div>

    </div>

</div>